import { registerEnumType } from 'type-graphql'

export enum AiBillingScopeEnum {
  Tenant = 'Tenant',
  User = 'User',
}

registerEnumType(AiBillingScopeEnum, {
  name: 'AiBillingScopeEnum',
  description:
    'Per-app billing scope for the shared AI usage-metering engine — Tenant shares one balance across every user in the tenant, User gives each user their own balance.',
})
